import { I18n } from 'aws-amplify'

export const AVAILABLE_MEASUREMENTS = [
  'temperature',
  'humidity',
  'par',
  'carbon_dioxide',
  'wind_speed',
  'vapour_pressure_deficit',
  'daily_light_integral',
  'soil_temperature',
  'soil_moisture',
  'soil_ph',
  'soil_ec',
  'soil_nitrogen',
  'soil_phosphorus',
  'soil_potassium'
]

export const getAvailableExpressions = () => [
  ['more', I18n.get('More than or equal to')],
  ['less', I18n.get('Less than or equal to')]
]

export const getAvailableBounds = () => [
  [I18n.get('Stress Lower')],
  [I18n.get('Bad Lower')],
  [I18n.get('Good Lower')],
  [I18n.get('Good Upper')],
  [I18n.get('Bad Upper')],
  [I18n.get('Stress Upper')]
]

export const getAvailablePriorities = () => [
  ['high', I18n.get('High')],
  ['medium', I18n.get('Medium')],
  ['low', I18n.get('Low')]
]

export const getAvailableProcessingMethods = () => [
  [
    'single',
    I18n.get('Single - Alert when any individual sensor meets the conditions')
  ],
  [
    'average',
    I18n.get(
      'Average - Alert when the zone’s average sensor data meets the conditions'
    )
  ]
]

export const getPriorityDisplayName = key => {
  const priorities = getAvailablePriorities()
  const priorityIndex = priorities.findIndex(p => p[0] === key)
  if (priorityIndex >= 0) {
    return priorities[priorityIndex][1]
  }
  return key
}
